import styled from "styled-components";
import { Button } from "antd";
import { MENU_COLORS } from "@lhd/constants";

export const ButtonWrapper = styled(Button)<{
  $type?: string;
  $disabled?: boolean;
  $missingRequire?: boolean;
  height: number;
}>`
  border-radius: 8px;
  border: 0;
  background-color: #174a83;
  padding: 0px 12px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-weight: 600;
  font-size: 15px;
  height: ${({ height }) => height}px !important;
  box-shadow: none;
  &.back-btn {
    background-color: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    min-width: 100px;
  }
  &.ant-btn-primary:disabled {
    border: 1px solid #d9d9d9;
  }
  &:hover,
  &:focus {
    background-color: #174a83;
    opacity: 0.9;
    color: #ffffff;
  }
  &:disabled {
    background-color: ${MENU_COLORS.DISABLED_BUTTON} !important;
    border: 1px solid #d9d9d9 !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;
    cursor: not-allowed;
  }

  &.ant-btn-dangerous.ant-btn-primary[disabled],
  &.ant-btn-dangerous.ant-btn-primary[disabled]:active,
  &.ant-btn-dangerous.ant-btn-primary[disabled]:focus,
  &.ant-btn-dangerous.ant-btn-primary[disabled]:hover {
    color: rgba(0, 0, 0, 0.25) !important;
    background: #f5f5f5 !important;
    border: 1px solid #d9d9d9 !important;
  }
  .arrow {
    width: 0;
    height: 0;
    position: absolute;
  }
  &.btn-small-background-white {
    background: #fff;
    color: #1f3666;
    border: 1px solid #1f3666;
  }

  &.btn-background-white {
    background: #fff;
    color: #1f3666;
    border: 1px solid #1f3666;
  }

  &.btn-new-cancel {
    background: #ea9999;
    color: #fff;
    border: 1px solid #ea9999;
  }

  &.btn-small-v {
    min-width: 18px;
    width: 18px !important;
    font-size: 10px !important;
    border-radius: 3px;
    position: relative;
    &.chevron-right {
      height: 32px !important;
      min-height: 10px !important;
      margin-top: 8px;
    }
    &.chevron-right .arrow {
      position: absolute;
      top: -8px;
      left: 0;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 10px solid #174a83;
    }
  }

  &.btn-back {
    background: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    min-width: 100px;
  }
  &.btn-submit {
    min-width: 120px;
    width: 120px;
  }
  &.button-arrow-right {
    clip-path: polygon(
      0% 0%,
      calc(100% - 16px) 0%,
      100% 50%,
      calc(100% - 16px) 100%,
      0% 100%
    );
  }

  /* Submit button with disabled state */
  ${({ $type, $disabled }) =>
    $type === "submit-btn" &&
    $disabled &&
    `
    background-color: ${MENU_COLORS.DISABLED_BUTTON} !important;
    border: 1px solid #d9d9d9  !important;
    color: ${MENU_COLORS.TEXT_WHITE}  !important;
    cursor: not-allowed !important;

   
    
    &:hover,
    &:focus {
      background-color: ${MENU_COLORS.DISABLED_BUTTON} !important;
      color: ${MENU_COLORS.TEXT_WHITE}  !important;
      opacity: 1 !important;
    }
  
    
  `}

  /* Submit button with missing require state */
  ${({ $type, $missingRequire, $disabled }) =>
    $type === "submit-btn" &&
    $missingRequire &&
    `
    background-color: ${MENU_COLORS.MISSING_REQUIRE} !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;

    ${
      !$disabled
        ? `
    
    &:hover,
    &:focus {
      background-color: ${MENU_COLORS.MISSING_REQUIRE_HOVER} !important;
      color: ${MENU_COLORS.TEXT_WHITE} !important;
      opacity: 0.9 !important;
    }
  `
        : ""
    }
  `}
  ${({ $type, $disabled }) =>
    $type === "cancel-btn" &&
    `
    background-color: ${MENU_COLORS.DELETE_ALL} !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;

    ${
      !$disabled
        ? `
      &:hover,
      &:focus {
        background-color: ${MENU_COLORS.DELETE_HOVER} !important;
        border: 1px solid ${MENU_COLORS.DELETE_HOVER} !important;
        color: ${MENU_COLORS.TEXT_WHITE} !important;
        opacity: 0.9 !important;
      }
    `
        : ""
    }
  `}
 ${({ $type }) =>
    $type === "delete-btn" &&
    `
  background-color: ${MENU_COLORS.NORMAL_DELETE} !important;
  color: ${MENU_COLORS.TEXT_WHITE} !important;
`}

${({ $type, $disabled }) =>
    $type === "delete-btn" &&
    !$disabled &&
    `
  &:hover,
  &:focus {
    background-color: ${MENU_COLORS.DELETE_HOVER} !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;
    opacity: 0.9 !important;
  }
`}
  
  &.back-btn {
    background-color: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    min-width: 100px;
  }
`;
